export enum DocumentTypeEnum {
  MedicalImaging      = '0000001C-1000-0000-0000-000000000001',
  ScreenShot          = '0000001C-1000-0000-0000-000000000002',
  Scan                = '0000001C-1000-0000-0000-000000000003',
  Correspondence      = '0000001C-1000-0000-0000-000000000004',
  CollageJSON         = '0000001C-1000-0000-0000-000000000005',
  Collage             = '0000001C-1000-0000-0000-000000000006',
  ImageCopyForCollage = '0000001C-1000-0000-0000-000000000007',
  Insurance = '0000001C-1000-0000-0000-000000000015'
}
